import { ERP_PLACEHOLDERS } from "./modules/fulfillment/erpPlaceholders";
﻿import { Suspense } from "react";
import { lazyRoute } from "./shell/lazyRoute";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { Shell } from "./shell/layout/Shell";
import { EvaWidget } from "./modules/eva";
import { LoginPage } from "./shell/components/LoginPage";
import { ProtectedRoute } from "./shell/auth/ProtectedRoute";
import { RestrictedRoute } from "./shell/auth/RestrictedRoute";
import { LoadingScreen } from "./shell/components/LoadingScreen";
import { appConfig } from "./lib/config/appConfig";

import { ToastProvider, ToastHost } from "./shell/components/Toast";
import { ConfettiProvider } from "./shell/components/Confetti";
import { HrisGuard } from "./modules/hris/HrisGuard";
import { SubconGuard } from "./modules/subcontractors/SubconGuard";
import { AuditLogGuard } from "./modules/mfg-workcenters/audit/AuditLogGuard";
// â”€â”€ Module registry â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Each module is code-split into its own bundle and only loaded when the user
// navigates to it. This is the single biggest reason SWA will outperform SPFx
// for your consolidated app.
const Home = lazyRoute("./modules/home/Home", () => import("./modules/home/Home"));
const HomeSettings = lazyRoute("./modules/home/HomeSettings", () => import("./modules/home/HomeSettings"));
const CrmGeomapping = lazyRoute("./modules/crm-geomapping", () => import("./modules/crm-geomapping"));
const B2bPipeline = lazyRoute("./modules/crm-b2b-pipeline", () => import("./modules/crm-b2b-pipeline").then((m) => ({ default: m.B2bPipeline })));
const B2bOrderDetail = lazyRoute("./modules/crm-b2b-pipeline", () => import("./modules/crm-b2b-pipeline").then((m) => ({ default: m.B2bOrderDetail })));
const HistoricalData = lazyRoute("./modules/crm-historical-orders", () => import("./modules/crm-historical-orders"));
const CustomerFeedback = lazyRoute("./modules/crm-feedback", () => import("./modules/crm-feedback"));
const IgCom = lazyRoute("./modules/crm-igcom", () => import("./modules/crm-igcom"));
const TikTok = lazyRoute("./modules/crm-tiktok", () => import("./modules/crm-tiktok"));
const Lazada = lazyRoute("./modules/crm-lazada", () => import("./modules/crm-lazada"));
const Ecommerce = lazyRoute("./modules/crm-ecommerce", () => import("./modules/crm-ecommerce"));
const EmbroideryRequest = lazyRoute("./modules/crm-embroidery/EmbroideryRequest", () => import("./modules/crm-embroidery/EmbroideryRequest"));
const ManufacturingProdPlan = lazyRoute("./modules/manufacturing-prodplan", () => import("./modules/manufacturing-prodplan"));
const ControlTower = lazyRoute("./modules/mfg-workcenters/bqc1/ControlTower", () => import("./modules/mfg-workcenters/bqc1/ControlTower"));
const WorkcentersValveAdmin = lazyRoute("./modules/mfg-workcenters/ValveAdmin", () => import("./modules/mfg-workcenters/ValveAdmin"));
const FulfillmentHandover = lazyRoute("./modules/mfg-workcenters/FulfillmentHandover", () => import("./modules/mfg-workcenters/FulfillmentHandover"));
const FulfillmentSourceSync = lazyRoute("./modules/mfg-workcenters/FulfillmentSourceSync", () => import("./modules/mfg-workcenters/FulfillmentSourceSync"));
const ErpTheirPage = lazyRoute("./modules/fulfillment/ErpTheirPage", () => import("./modules/fulfillment/ErpTheirPage"));
const ErpOrderDatabase = lazyRoute("./modules/fulfillment", () => import("./modules/fulfillment"));
const ErpHome = lazyRoute("./modules/fulfillment/ErpHome", () => import("./modules/fulfillment/ErpHome"));
const ErpAccountsReceivable = lazyRoute("./modules/fulfillment/ErpAccountsReceivable", () => import("./modules/fulfillment/ErpAccountsReceivable"));
const ErpInboundForgot = lazyRoute("./modules/fulfillment/ErpInboundForgot", () => import("./modules/fulfillment/ErpInboundForgot"));
const ErpInbound = lazyRoute("./modules/fulfillment/ErpInbound", () => import("./modules/fulfillment/ErpInbound"));
const ErpOrderMonitoring = lazyRoute("./modules/fulfillment/ErpOrderMonitoring", () => import("./modules/fulfillment/ErpOrderMonitoring"));
const ErpReserved = lazyRoute("./modules/fulfillment/ErpReserved", () => import("./modules/fulfillment/ErpReserved"));
const ErpAssigning = lazyRoute("./modules/fulfillment/ErpAssigning", () => import("./modules/fulfillment/ErpAssigning"));
const ErpMessages = lazyRoute("./modules/fulfillment/ErpMessages", () => import("./modules/fulfillment/ErpMessages"));
const ErpAuditLog = lazyRoute("./modules/fulfillment/ErpAuditLog", () => import("./modules/fulfillment/ErpAuditLog"));
const ErpBackupLog = lazyRoute("./modules/fulfillment/ErpBackupLog", () => import("./modules/fulfillment/ErpBackupLog"));
const ErpCancelledOrders = lazyRoute("./modules/fulfillment/ErpCancelledOrders", () => import("./modules/fulfillment/ErpCancelledOrders"));
const ErpCutting = lazyRoute("./modules/fulfillment/ErpCutting", () => import("./modules/fulfillment/ErpCutting"));
const ErpEmbroLayout = lazyRoute("./modules/fulfillment/ErpEmbroLayout", () => import("./modules/fulfillment/ErpEmbroLayout"));
const ErpEmbroideryRequest = lazyRoute("./modules/fulfillment/ErpEmbroideryRequest", () => import("./modules/fulfillment/ErpEmbroideryRequest"));
const ErpInvoiceRequest = lazyRoute("./modules/fulfillment/ErpInvoiceRequest", () => import("./modules/fulfillment/ErpInvoiceRequest"));
const ErpManageUsers = lazyRoute("./modules/fulfillment/ErpManageUsers", () => import("./modules/fulfillment/ErpManageUsers"));
const ErpFinishedGoods = lazyRoute("./modules/fulfillment/ErpFinishedGoods", () => import("./modules/fulfillment/ErpFinishedGoods"));
const ErpForAssigning = lazyRoute("./modules/fulfillment/ErpForAssigning", () => import("./modules/fulfillment/ErpForAssigning"));
const ErpForCutting = lazyRoute("./modules/fulfillment/ErpForCutting", () => import("./modules/fulfillment/ErpForCutting"));
const ErpHistory = lazyRoute("./modules/fulfillment/ErpHistory", () => import("./modules/fulfillment/ErpHistory"));
const ErpManufacturingOrder = lazyRoute("./modules/fulfillment/ErpManufacturingOrder", () => import("./modules/fulfillment/ErpManufacturingOrder"));
const ErpMasterFile = lazyRoute("./modules/fulfillment/ErpMasterFile", () => import("./modules/fulfillment/ErpMasterFile"));
const ErpOrderCompleted = lazyRoute("./modules/fulfillment/ErpOrderCompleted", () => import("./modules/fulfillment/ErpOrderCompleted"));
const ErpQcFailed = lazyRoute("./modules/fulfillment/ErpQcFailed", () => import("./modules/fulfillment/ErpQcFailed"));
const ErpQcPassed = lazyRoute("./modules/fulfillment/ErpQcPassed", () => import("./modules/fulfillment/ErpQcPassed"));
const ErpReceiving = lazyRoute("./modules/fulfillment/ErpReceiving", () => import("./modules/fulfillment/ErpReceiving"));
const ErpRejectNotification = lazyRoute("./modules/fulfillment/ErpRejectNotification", () => import("./modules/fulfillment/ErpRejectNotification"));
const ErpSampleRequest = lazyRoute("./modules/fulfillment/ErpSampleRequest", () => import("./modules/fulfillment/ErpSampleRequest"));
const ErpWeeklyReference = lazyRoute("./modules/fulfillment/ErpWeeklyReference", () => import("./modules/fulfillment/ErpWeeklyReference"));
const ErpFulfillmentRtg = lazyRoute("./modules/fulfillment/ErpFulfillmentRtg", () => import("./modules/fulfillment/ErpFulfillmentRtg"));
const ErpCuttingOutput = lazyRoute("./modules/fulfillment/ErpCuttingOutput", () => import("./modules/fulfillment/ErpCuttingOutput"));
const ErpSalesOutput = lazyRoute("./modules/fulfillment/ErpSalesOutput", () => import("./modules/fulfillment/ErpSalesOutput"));
const ErpPendingOutput = lazyRoute("./modules/fulfillment/ErpPendingOutput", () => import("./modules/fulfillment/ErpPendingOutput"));
const ErpFinishedGoodsOutput = lazyRoute("./modules/fulfillment/ErpFinishedGoodsOutput", () => import("./modules/fulfillment/ErpFinishedGoodsOutput"));
const ErpReservedOutput = lazyRoute("./modules/fulfillment/ErpReservedOutput", () => import("./modules/fulfillment/ErpReservedOutput"));
const ErpForecast = lazyRoute("./modules/fulfillment/ErpForecast", () => import("./modules/fulfillment/ErpForecast"));
const ErpFulfillmentOutput = lazyRoute("./modules/fulfillment/ErpFulfillmentOutput", () => import("./modules/fulfillment/ErpFulfillmentOutput"));
const ErpOrderToFulfill = lazyRoute("./modules/fulfillment/ErpOrderToFulfill", () => import("./modules/fulfillment/ErpOrderToFulfill"));
const ErpToCutting = lazyRoute("./modules/fulfillment/ErpToCutting", () => import("./modules/fulfillment/ErpToCutting"));
const ErpToConjunc = lazyRoute("./modules/fulfillment/ErpToConjunc", () => import("./modules/fulfillment/ErpToConjunc"));
const ErpFulfilledOrders = lazyRoute("./modules/fulfillment/ErpFulfilledOrders", () => import("./modules/fulfillment/ErpFulfilledOrders"));
const ErpLsrNfr = lazyRoute("./modules/fulfillment/ErpLsrNfr", () => import("./modules/fulfillment/ErpLsrNfr"));
const ErpOutbound = lazyRoute("./modules/fulfillment/ErpOutbound", () => import("./modules/fulfillment/ErpOutbound"));
const ErpSpecialOutbound = lazyRoute("./modules/fulfillment/ErpSpecialOutbound", () => import("./modules/fulfillment/ErpSpecialOutbound"));
const ErpSampleMonitoring = lazyRoute("./modules/fulfillment/ErpSampleMonitoring", () => import("./modules/fulfillment/ErpSampleMonitoring"));
const ErpPackaging = lazyRoute("./modules/fulfillment/ErpPackaging", () => import("./modules/fulfillment/ErpPackaging"));
const ErpDropOff = lazyRoute("./modules/fulfillment/ErpDropOff", () => import("./modules/fulfillment/ErpDropOff"));
const ErpReturnManagement = lazyRoute("./modules/fulfillment/ErpReturnManagement", () => import("./modules/fulfillment/ErpReturnManagement"));
const ErpReturnRecon = lazyRoute("./modules/fulfillment/ErpReturnRecon", () => import("./modules/fulfillment/ErpReturnRecon"));
const ErpReturnOutput = lazyRoute("./modules/fulfillment/ErpReturnOutput", () => import("./modules/fulfillment/ErpReturnOutput"));
const ErpFulfillmentMonitoring = lazyRoute("./modules/fulfillment/ErpFulfillmentMonitoring", () => import("./modules/fulfillment/ErpFulfillmentMonitoring"));
const ErpLsrNfrResult = lazyRoute("./modules/fulfillment/ErpLsrNfrResult", () => import("./modules/fulfillment/ErpLsrNfrResult"));
const ErpAssigningOutput = lazyRoute("./modules/fulfillment/ErpAssigningOutput", () => import("./modules/fulfillment/ErpAssigningOutput"));
const ErpReceivingOutput = lazyRoute("./modules/fulfillment/ErpReceivingOutput", () => import("./modules/fulfillment/ErpReceivingOutput"));
const ErpQcOutput = lazyRoute("./modules/fulfillment/ErpQcOutput", () => import("./modules/fulfillment/ErpQcOutput"));
const ErpPlaceholder = lazyRoute("./modules/fulfillment/ErpPlaceholder", () => import("./modules/fulfillment/ErpPlaceholder"));
const ErpWorkInProgress = lazyRoute("./modules/fulfillment/ErpWorkInProgress", () => import("./modules/fulfillment/ErpWorkInProgress"));
const ErpDeleteAllData = lazyRoute("./modules/fulfillment/ErpDeleteAllData", () => import("./modules/fulfillment/ErpDeleteAllData"));
const ErpSewerDetails = lazyRoute("./modules/fulfillment/ErpSewerDetails", () => import("./modules/fulfillment/ErpSewerDetails"));
const ErpSewerCompetencies = lazyRoute("./modules/fulfillment/ErpSewerDetails", () => import("./modules/fulfillment/ErpSewerDetails").then((m) => ({ default: m.ErpSewerCompetencies })));
const ErpManufacturingOutput = lazyRoute("./modules/fulfillment/ErpManufacturingOutput", () => import("./modules/fulfillment/ErpManufacturingOutput"));
const ErpPackagingOutput = lazyRoute("./modules/fulfillment/ErpPackagingOutput", () => import("./modules/fulfillment/ErpPackagingOutput"));
const ErpInboundOutput = lazyRoute("./modules/fulfillment/ErpInboundOutput", () => import("./modules/fulfillment/ErpInboundOutput"));
const ErpOutboundOutput = lazyRoute("./modules/fulfillment/ErpOutboundOutput", () => import("./modules/fulfillment/ErpOutboundOutput"));
const ErpDropOffPickupOutput = lazyRoute("./modules/fulfillment/ErpDropOffPickupOutput", () => import("./modules/fulfillment/ErpDropOffPickupOutput"));
const ErpFulfillmentGrid = lazyRoute("./modules/fulfillment/ErpFulfillmentGrid", () => import("./modules/fulfillment/ErpFulfillmentGrid"));
const ErpSummary = lazyRoute("./modules/fulfillment/ErpSummary", () => import("./modules/fulfillment/ErpSummary"));
const ErpAnalytics = lazyRoute("./modules/fulfillment/ErpAnalytics", () => import("./modules/fulfillment/ErpAnalytics"));
const ErpReporting = lazyRoute("./modules/fulfillment/ErpReporting", () => import("./modules/fulfillment/ErpReporting"));
// Availability and the Assignment Board are one screen in two tabs — see
// bqc1/Planning.tsx. Both URLs stay real so every deep link keeps working.
const WorkcentersPlanning = lazyRoute("./modules/mfg-workcenters/bqc1/Planning", () => import("./modules/mfg-workcenters/bqc1/Planning"));
const WorkcentersCutting = lazyRoute("./modules/mfg-workcenters/bqc2/Cutting", () => import("./modules/mfg-workcenters/bqc2/Cutting"));
const WorkcentersDispatch = lazyRoute("./modules/mfg-workcenters/bqc3/Dispatch", () => import("./modules/mfg-workcenters/bqc3/Dispatch"));
const WorkcentersReceiving = lazyRoute("./modules/mfg-workcenters/bqc4/Receiving", () => import("./modules/mfg-workcenters/bqc4/Receiving"));
const WorkcentersQc = lazyRoute("./modules/mfg-workcenters/bqc5/Qc", () => import("./modules/mfg-workcenters/bqc5/Qc"));
const ManuMonitoring = lazyRoute("./modules/mfg-workcenters/monitoring/ManuMonitoring", () => import("./modules/mfg-workcenters/monitoring/ManuMonitoring"));
const WorkcentersGate1 = lazyRoute("./modules/mfg-workcenters/bqc1/Gate1Report", () => import("./modules/mfg-workcenters/bqc1/Gate1Report"));
const WorkcentersRoster = lazyRoute("./modules/mfg-workcenters/bqc1/RosterDiagnostics", () => import("./modules/mfg-workcenters/bqc1/RosterDiagnostics"));
const WorkcentersMetrics = lazyRoute("./modules/mfg-workcenters/bqc1/SewerMetrics", () => import("./modules/mfg-workcenters/bqc1/SewerMetrics"));
const WorkcentersWhatIf = lazyRoute("./modules/mfg-workcenters/bqc1/WhatIf", () => import("./modules/mfg-workcenters/bqc1/WhatIf"));
const WorkcentersIntel = lazyRoute("./modules/mfg-workcenters/bqc1/SewerIntel", () => import("./modules/mfg-workcenters/bqc1/SewerIntel"));
const WorkcentersSubcontractors = lazyRoute("./modules/mfg-workcenters/bqc1/Subcontractors", () => import("./modules/mfg-workcenters/bqc1/Subcontractors"));
const WorkcentersSettings = lazyRoute("./modules/mfg-workcenters/bqc1/WorkcenterSettings", () => import("./modules/mfg-workcenters/bqc1/WorkcenterSettings"));
const AuditLog = lazyRoute("./modules/mfg-workcenters/audit/AuditLog", () => import("./modules/mfg-workcenters/audit/AuditLog"));
const WorkcentersSewerDetail = lazyRoute("./modules/mfg-workcenters/bqc1/SewerDetail", () => import("./modules/mfg-workcenters/bqc1/SewerDetail"));
const ProductionGrid = lazyRoute("./modules/production-grid", () => import("./modules/production-grid"));
const ProductionGridBatchDetail = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.BatchDetail })));
const ProductionGridSettings = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.GridSettings })));
const ProductionGridOutputHistory = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.OutputHistory })));
const ProductionGridOutputHistoryAll = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.OutputHistoryAll })));
const ProductionGridSimulation = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.SimulationTool })));
const ProductionGridPending = lazyRoute("./modules/production-grid", () => import("./modules/production-grid").then((m) => ({ default: m.PendingBreakdown })));
const RmcInventory = lazyRoute("./modules/rmc-inventory/RmcInventory", () => import("./modules/rmc-inventory/RmcInventory"));
const InventoryRmc = lazyRoute("./modules/inventory-rmc", () => import("./modules/inventory-rmc"));
const SalesInvoice = lazyRoute("./modules/accounting-sales-invoice", () => import("./modules/accounting-sales-invoice").then((m) => ({ default: m.SalesInvoice })));
const BillsRegistry = lazyRoute("./modules/accounting-bills-registry", () => import("./modules/accounting-bills-registry").then((m) => ({ default: m.BillsRegistry })));
const DailyExpenses = lazyRoute("./modules/accounting-daily-expenses", () => import("./modules/accounting-daily-expenses").then((m) => ({ default: m.DailyExpenses })));
const OutdoorExpenses = lazyRoute("./modules/outdoor-activity", () => import("./modules/outdoor-activity").then((m) => ({ default: m.EventExpenses })));
const OutdoorSales = lazyRoute("./modules/outdoor-activity", () => import("./modules/outdoor-activity").then((m) => ({ default: m.SalesIncome })));
const Bookkeeping = lazyRoute("./modules/accounting-bookkeeping", () => import("./modules/accounting-bookkeeping").then((m) => ({ default: m.Bookkeeping })));
const ApDashboard = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.ApDashboard })));
const ArDashboard = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.ArDashboard })));
const FlowStep = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.FlowStep })));
const AcctSettings = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.AcctSettings })));
const PurchaseOrders = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.PurchaseOrders })));
const GoodsReceiptNotes = lazyRoute("./modules/accounting-flow", () => import("./modules/accounting-flow").then((m) => ({ default: m.GoodsReceiptNotes })));
const HrisPayrollCalc = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.PayrollCalc })));
const HrisComputation = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.PayrollComputation })));
const HrisBankFile = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.BankFile })));
const HrisBenefits = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.MandatoryBenefits })));
const HrisThirteenth = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.ThirteenthMonth })));
const HrisEmployees = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Employees })));
const HrisAttendance = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Attendance })));
const HrisLeaves = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Leaves })));
const HrisLoans = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Loans })));
const HrisPayslips = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Payslips })));
const HrisSettings = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.HrisSettings })));
const HrisDiscover = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.HrisDiscover })));
const HrisPayrollPeriods = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.PayrollPeriods })));
const HrisReports = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Reports })));
const HrisEmployee201 = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Employee201 })));
const HrisAttendanceSummary = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.AttendanceSummary })));
const HrisHolidays = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.HolidaysDayTypes })));
const HrisLeaveTypes = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.LeaveTypes })));
const HrisLeaveCredits = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.LeaveCredits })));
const HrisLeaveRecon = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.LeaveRecon })));
const HrisRolesUsers = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.RolesUsers })));
const HrisWorkSchedules = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.WorkSchedules })));
const Bir1601C = lazyRoute("./modules/bir", () => import("./modules/bir").then((m) => ({ default: m.Bir1601C })));
const BirPayrollWorkbook = lazyRoute("./modules/bir", () => import("./modules/bir").then((m) => ({ default: m.PayrollWorkbook })));
const HrisScoreboard = lazyRoute("./modules/hris", () => import("./modules/hris").then((m) => ({ default: m.Scoreboard })));
// SUBCONTRACTORS — the subcontractor payroll module. Its quantities come from
// BQC5's QC scans, so it sits beside Manufacturing rather than inside HRIS,
// which pays employees under an entirely different set of rules.
const SubconDirectory = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.Directory })));
const SubconPayrollRun = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.PayrollRun })));
const SubconPayrollOne = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.PayrollSubcon })));
const SubconPayslip = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.Payslip })));
const SubconRecords = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.PayoutRecords })));
const SubconRateCard = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.RateCardScreen })));
const SubconBizlink = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.Bizlink })));
const SewerPortal = lazyRoute("./modules/sewer-portal/SewerPortal", () => import("./modules/sewer-portal/SewerPortal"));
const SewerPortalAdmin = lazyRoute("./modules/sewer-portal/PortalAdmin", () => import("./modules/sewer-portal/PortalAdmin"));
const SubconSettings = lazyRoute("./modules/subcontractors", () => import("./modules/subcontractors").then((m) => ({ default: m.PayrollSettings })));

// Placeholders â€” uncomment as each module gets migrated.
// const Inventory = lazyRoute("./modules/inventory", () => import("./modules/inventory"));
// const Manufacturing = lazyRoute("./modules/manufacturing", () => import("./modules/manufacturing"));
// const ExcelOrganizer = lazyRoute("./modules/excel-organizer", () => import("./modules/excel-organizer"));
// const Rmc = lazyRoute("./modules/rmc", () => import("./modules/rmc"));

export function App() {
  return (
    <ToastProvider><ConfettiProvider><Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <Home />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/home/settings"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <HomeSettings />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* OUTSIDE <Shell />, deliberately. The fulfillment module is a mirror of
          the ERP and brings THEIR sidebar and topbar (ErpShell) -- two shells on
          one screen is not what "clone copy" means. /home already renders
          outside the Shell, so the pattern is theirs, not a new one. */}
      <Route
        path="/fulfillment/home"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpHome />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/order-database"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOrderDatabase />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/inbound"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpInbound />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/inbound-forgot"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpInboundForgot />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/order-monitoring"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOrderMonitoring />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/fulfilled-orders"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFulfilledOrders />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/lsr-nfr"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpLsrNfr />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/to-cutting"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpToCutting />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/to-conjunc"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpToConjunc />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/pending-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpPendingOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/finished-goods-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFinishedGoodsOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/reserved-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReservedOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/forecast"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpForecast />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/fulfillment-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFulfillmentOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/order-to-fulfill"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOrderToFulfill />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/assigning"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpAssigning />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/messages"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpMessages />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/audit-log"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpAuditLog />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/backup-log"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpBackupLog />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/cancelled-orders"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpCancelledOrders />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/cutting"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpCutting />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/embro-layout"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpEmbroLayout />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/invoice-request"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpInvoiceRequest />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/manage-users"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpManageUsers />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/embroidery-request"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpEmbroideryRequest />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/finished-goods"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFinishedGoods />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/for-assigning"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpForAssigning />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/for-cutting"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpForCutting />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/history"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpHistory />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/manufacturing-order"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpManufacturingOrder />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/master-file"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpMasterFile />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/order-completed"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOrderCompleted />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/accounts-receivable"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpAccountsReceivable />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/reserved"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReserved />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/qc-failed"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpQcFailed />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/qc-passed"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpQcPassed />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/receiving"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReceiving />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/reject-notification"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpRejectNotification />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sample-request"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSampleRequest />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/weekly-reference"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpWeeklyReference />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sales-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSalesOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/cutting-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpCuttingOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/fulfillment-rtg"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFulfillmentRtg />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/outbound"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOutbound />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/special-outbound"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSpecialOutbound />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sample-monitoring"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSampleMonitoring />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/packaging"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpPackaging />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/drop-off"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpDropOff />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/return-management"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReturnManagement />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/return-recon"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReturnRecon />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/return-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReturnOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/fulfillment-monitoring"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFulfillmentMonitoring />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/lsr-nfr-result"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpLsrNfrResult />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/manufacturing-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpManufacturingOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/assigning-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpAssigningOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/receiving-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReceivingOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/qc-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpQcOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sewer-details"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSewerDetails />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sewer-sku-competencies"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSewerCompetencies />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/delete-all-data"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpDeleteAllData />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/work-in-progress"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpWorkInProgress />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {Object.keys(ERP_PLACEHOLDERS).map((key) => (
        <Route
          key={key}
          path={`/fulfillment/${key.replace(/_/g, "-")}`}
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <ErpPlaceholder endpoint={key} />
              </Suspense>
            </ProtectedRoute>
          }
        />
      ))}
      <Route
        path="/fulfillment/packaging-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpPackagingOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/inbound-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpInboundOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/outbound-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpOutboundOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/dropoff-pickup-output"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpDropOffPickupOutput />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/fulfillment-grid"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpFulfillmentGrid />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/inbound-report"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpTheirPage name="inbound_report" />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/rtg-dashboard"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpTheirPage name="rtg_dashboard" />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/ecommerce-report"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpTheirPage name="ecommerce_report" />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/sales-report"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpTheirPage name="sales_report" />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/summary"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpSummary />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/analytics"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpAnalytics />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfillment/reporting"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingScreen />}>
              <ErpReporting />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route
          path="/crm/b2b"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <B2bPipeline />
            </Suspense>
          }
        />
        <Route
          path="/crm/b2b/:orderId"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <B2bOrderDetail />
            </Suspense>
          }
        />
        <Route
          path="/crm/historical"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <HistoricalData />
            </Suspense>
          }
        />
        <Route
          path="/crm/feedback"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <CustomerFeedback />
            </Suspense>
          }
        />
        <Route
          path="/crm/igcom"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <IgCom />
            </Suspense>
          }
        />
        <Route
          path="/crm/tiktok"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <TikTok />
            </Suspense>
          }
        />
        <Route
          path="/crm/ecommerce"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <Ecommerce />
            </Suspense>
          }
        />
        <Route
          path="/crm/lazada"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <Lazada />
            </Suspense>
          }
        />
        <Route
          path="/crm/embroidery"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <EmbroideryRequest />
            </Suspense>
          }
        />
        <Route
          path="/crm/embroidery/monitoring"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <EmbroideryRequest />
            </Suspense>
          }
        />
        <Route
          path="/crm/*"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <CrmGeomapping />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/prodplan"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManufacturingProdPlan />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/cutting"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersCutting />
            </Suspense>
          }
        />
        {/* The WO log recon tab. Same component: it already holds the WIPs and
            the scans both sides read, so routing to a second one would load
            the lot twice to show a different half of it. */}
        <Route
          path="/manufacturing/cutting/wo-log"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersCutting />
            </Suspense>
          }
        />
        {/* The Cutter output tab. Same component again, and for the same
            reason: it is built from the cut-ready scans this screen has
            already loaded. */}
        <Route
          path="/manufacturing/cutting/output"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersCutting />
            </Suspense>
          }
        />
        {/* The retired Workbook recon tab (Mikko, 2026-09-09). The route stays
            so a bookmark still opens Cutting rather than a blank page — the
            screen sends it to the station. */}
        <Route
          path="/manufacturing/cutting/workbook"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersCutting />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/dispatch"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersDispatch />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/receiving"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersReceiving />
            </Suspense>
          }
        />
        {/* Receiving's queue tab: the sewers' Delivery Receipts (was Sewer Portal Admin → Receiving Queue). */}
        <Route
          path="/manufacturing/receiving/queue"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersReceiving />
            </Suspense>
          }
        />
        {/* Receiving's DS ↔ DR reconciliation tab — see the cutting note. */}
        <Route
          path="/manufacturing/receiving/reconciliation"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersReceiving />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/qc"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersQc />
            </Suspense>
          }
        />
        {/* QC's DS ↔ DR reconciliation tab — see the cutting note. */}
        <Route
          path="/manufacturing/qc/reconciliation"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersQc />
            </Suspense>
          }
        />
        {/* QC's output tab — sets passed and failed per inspector. */}
        <Route
          path="/manufacturing/qc/output"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersQc />
            </Suspense>
          }
        />
        {/* QC's Payable Slip tab. */}
        <Route
          path="/manufacturing/qc/payable-slip"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersQc />
            </Suspense>
          }
        />
        {/* QC's userform import tab. */}
        <Route
          path="/manufacturing/qc/import"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersQc />
            </Suspense>
          }
        />
        {/* Manu Monitoring — five tabs, one screen. The tab IS the URL, the
            same way the stations do it, so a deep link keeps working and Back
            does what Back should. */}
        <Route
          path="/manufacturing/monitoring"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManuMonitoring />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/monitoring/pending"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManuMonitoring />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/monitoring/stores"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManuMonitoring />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/monitoring/done"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManuMonitoring />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/monitoring/import"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ManuMonitoring />
            </Suspense>
          }
        />
        {/* Control Tower's Import tab — the tab IS the URL, as on the
            stations, so a deep link keeps working and Back does what Back
            should. Same component; it reads the path. */}
        <Route
          path="/manufacturing/work-orders/import"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        {/* Cutter Assigning — the morning reset. Same component; the tab IS
            the URL, so a planner can bookmark the one screen they open first
            every morning. */}
        <Route
          path="/manufacturing/work-orders/cutter-assign"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        {/* Control Tower's BQC1 board — the planner's own table, and what
            the screen's BARE path now opens (see TOWER_PATH in ControlTower).
            This address came first and stays routed so a bookmark still lands
            on it. Same component; the tab IS the URL here as on the stations. */}
        <Route
          path="/manufacturing/work-orders/bqc1"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        {/* Control Tower's W.O. Logs — every series, to print in bulk or edit.
            Same component; the tab IS the URL here as on the stations. */}
        <Route
          path="/manufacturing/work-orders/wo-logs"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        {/* Generate Prod Tag — it used to sit on the bare path and the board
            had to be clicked to reach. The board landing first is what Mikko
            asked for, so the tag printer takes a URL of its own rather than
            becoming the one panel on this screen without one. */}
        <Route
          path="/manufacturing/work-orders/tags"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ControlTower />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/availability"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersPlanning />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/settings"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersSettings />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/audit-log"
          element={
            <AuditLogGuard>
              <Suspense fallback={<LoadingScreen />}>
                <AuditLog />
              </Suspense>
            </AuditLogGuard>
          }
        />
        <Route
          path="/manufacturing/work-orders/sewer/:sewer"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersSewerDetail />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/sewers"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersIntel />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/subcontractors"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersSubcontractors />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/board"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersPlanning />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/what-if"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersWhatIf />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/metrics"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersMetrics />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/roster"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersRoster />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/gate1"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersGate1 />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/work-orders/valve"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <WorkcentersValveAdmin />
            </Suspense>
          }
        />
        {/* Hands BQC1-BQC5 to the fulfillment team's ERP as the workbook its
            own import pages accept. Read-only: builds a file, writes nothing. */}
        <Route
          path="/manufacturing/fulfillment-handover"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <FulfillmentHandover />
            </Suspense>
          }
        />
        {/* Keeps the FULFILLMENT GitHub repo (this app's only view of their
            source) current with their OneDrive folder — read-only there,
            upsert-only here. See FulfillmentSourceSync.tsx. */}
        <Route
          path="/manufacturing/fulfillment-source-sync"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <FulfillmentSourceSync />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGrid />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/settings"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridSettings />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/simulation"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridSimulation />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/history-all"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridOutputHistoryAll />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/history/:stage"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridOutputHistory />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/pending"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridPending />
            </Suspense>
          }
        />
        <Route
          path="/manufacturing/production-grid/:batchCode"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ProductionGridBatchDetail />
            </Suspense>
          }
        />
        <Route
          path="/rmc/*"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <RmcInventory />
            </Suspense>
          }
        />
        <Route
          path="/inventory/rmc/*"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <InventoryRmc />
            </Suspense>
          }
        />
        {/* The Dashboard is withdrawn for now (Mikko, 2026-09-12), so the
            module's own root lands on the screen the work actually starts
            from. A redirect rather than a removed route: /hris is linked from
            the app's home tiles and from bookmarks, and a dead link there
            would read as the whole module being gone. */}
        <Route path="/hris" element={<Navigate to="/hris/payroll" replace />} />
        <Route
          path="/hris/payroll"
          element={
            <HrisGuard screen="payroll">
              <Suspense fallback={<LoadingScreen />}>
                <HrisPayrollCalc />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/computation"
          element={
            <HrisGuard screen="computation">
              <Suspense fallback={<LoadingScreen />}>
                <HrisComputation />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/bankfile"
          element={
            <HrisGuard screen="bankfile">
              <Suspense fallback={<LoadingScreen />}>
                <HrisBankFile />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/benefits"
          element={
            <HrisGuard screen="benefits">
              <Suspense fallback={<LoadingScreen />}>
                <HrisBenefits />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/thirteenth"
          element={
            <HrisGuard screen="thirteenth">
              <Suspense fallback={<LoadingScreen />}>
                <HrisThirteenth />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/employees"
          element={
            <HrisGuard screen="employees">
              <Suspense fallback={<LoadingScreen />}>
                <HrisEmployees />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/attendance"
          element={
            <HrisGuard screen="attendance">
              <Suspense fallback={<LoadingScreen />}>
                <HrisAttendance />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/leaves"
          element={
            <HrisGuard screen="leaves">
              <Suspense fallback={<LoadingScreen />}>
                <HrisLeaves />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/loans"
          element={
            <HrisGuard screen="loans">
              <Suspense fallback={<LoadingScreen />}>
                <HrisLoans />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/payslips"
          element={
            <HrisGuard screen="payslips">
              <Suspense fallback={<LoadingScreen />}>
                <HrisPayslips />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/settings"
          element={
            <HrisGuard requireFull>
              <Suspense fallback={<LoadingScreen />}>
                <HrisSettings />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/discover"
          element={
            <HrisGuard requireFull>
              <Suspense fallback={<LoadingScreen />}>
                <HrisDiscover />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/periods"
          element={
            <HrisGuard screen="periods">
              <Suspense fallback={<LoadingScreen />}>
                <HrisPayrollPeriods />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/scoreboard"
          element={
            <HrisGuard screen="scoreboard">
              <Suspense fallback={<LoadingScreen />}>
                <HrisScoreboard />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/subcontractors"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconDirectory />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/payroll"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconPayrollRun />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/payroll/:sewer"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconPayrollOne />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/records"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconRecords />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/payout/:payoutRef"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconPayslip />
              </Suspense>
            </SubconGuard>
          }
        />
        {/* The old path, kept working. The screen was renamed Payout on
            2026-09-21 and every link in the app now points at /payout/, but a
            reference somebody bookmarked or pasted into a chat must not 404 —
            a payout reference is how a clerk finds one payslip among five
            thousand. Same screen, same guard, no redirect to get wrong. */}
        <Route
          path="/subcontractors/payslip/:payoutRef"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconPayslip />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/rates"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconRateCard />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/subcontractors/bizlink"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconBizlink />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/sewer"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sewer/scan"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal tab="scan" />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sewer/dr"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal tab="dr" />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sewer/status"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal tab="status" />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sewer/payout"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal tab="payout" />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sewer/me"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortal tab="me" />
              </Suspense>
            </ProtectedRoute>
          }
        />
        {/* Sewer Portal Admin is gone (Mikko, 2026-10-31): its Receiving Queue is a tab of BQC4 Receiving and
            Accounts & Publish is under Manufacturing → Settings. The old addresses still land in the right place. */}
        <Route path="/sewer-admin" element={<Navigate to="/manufacturing/sewer-portal" replace />} />
        <Route path="/sewer-admin/queue" element={<Navigate to="/manufacturing/receiving/queue" replace />} />
        <Route
          path="/manufacturing/sewer-portal"
          element={
            <ProtectedRoute>
              <Suspense fallback={<LoadingScreen />}>
                <SewerPortalAdmin />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/subcontractors/settings"
          element={
            <SubconGuard>
              <Suspense fallback={<LoadingScreen />}>
                <SubconSettings />
              </Suspense>
            </SubconGuard>
          }
        />
        <Route
          path="/hris/reports"
          element={
            <HrisGuard screen="reports">
              <Suspense fallback={<LoadingScreen />}>
                <HrisReports />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/attendance-summary"
          element={
            <HrisGuard screen="attendance">
              <Suspense fallback={<LoadingScreen />}>
                <HrisAttendanceSummary />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/roles"
          element={
            <HrisGuard requireFull>
              <Suspense fallback={<LoadingScreen />}>
                <HrisRolesUsers />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/leave-credits"
          element={
            <HrisGuard screen="leaves">
              <Suspense fallback={<LoadingScreen />}>
                <HrisLeaveCredits />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/leave-recon"
          element={
            <HrisGuard screen="leaves">
              <Suspense fallback={<LoadingScreen />}>
                <HrisLeaveRecon />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/leave-types"
          element={
            <HrisGuard screen="leaves">
              <Suspense fallback={<LoadingScreen />}>
                <HrisLeaveTypes />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/schedules"
          element={
            <HrisGuard screen="attendance">
              <Suspense fallback={<LoadingScreen />}>
                <HrisWorkSchedules />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/holidays"
          element={
            <HrisGuard screen="attendance">
              <Suspense fallback={<LoadingScreen />}>
                <HrisHolidays />
              </Suspense>
            </HrisGuard>
          }
        />
        <Route
          path="/hris/201"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <HrisEmployee201 />
            </Suspense>
          }
        />
        <Route
          path="/hris/workbook"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <BirPayrollWorkbook />
            </Suspense>
          }
        />
        <Route
          path="/hris/1601c"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <Bir1601C />
            </Suspense>
          }
        />
        {/*
        <Route path="/inventory/*" element={<Suspense fallback={<LoadingScreen />}><Inventory /></Suspense>} />
        <Route path="/manufacturing/*" element={<Suspense fallback={<LoadingScreen />}><Manufacturing /></Suspense>} />
        <Route path="/excel-organizer/*" element={<Suspense fallback={<LoadingScreen />}><ExcelOrganizer /></Suspense>} />
        <Route path="/rmc/*" element={<Suspense fallback={<LoadingScreen />}><Rmc /></Suspense>} />
        */}
        <Route
          path="/accounting/sales-invoice"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <SalesInvoice />
            </Suspense>
          }
        />
        {/* The register behind the booklet — same screen, second tab. The tab
            is the URL, the way the stations do it, so this is a route rather
            than component state. */}
        <Route
          path="/accounting/sales-invoice/bookkeeping"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <SalesInvoice />
            </Suspense>
          }
        />
        <Route
          path="/accounting/bills-registry"
          element={
            <RestrictedRoute allowedUsers={appConfig.billsRegistryAllowedUsers} moduleName="Bills & Subscriptions">
              <Suspense fallback={<LoadingScreen />}>
                <BillsRegistry />
              </Suspense>
            </RestrictedRoute>
          }
        />
        <Route
          path="/accounting/daily-expenses"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <DailyExpenses />
            </Suspense>
          }
        />
        <Route
          path="/outdoor"
          element={<Navigate to="/outdoor/expenses" replace />}
        />
        <Route
          path="/outdoor/expenses"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <OutdoorExpenses />
            </Suspense>
          }
        />
        <Route
          path="/outdoor/sales"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <OutdoorSales />
            </Suspense>
          }
        />
        <Route
          path="/accounting/bookkeeping"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <Bookkeeping />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ap"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ApDashboard />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ap/po"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <PurchaseOrders />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ap/grn"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <GoodsReceiptNotes />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ap/:step"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <FlowStep side="ap" />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ar"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <ArDashboard />
            </Suspense>
          }
        />
        <Route
          path="/accounting/ar/:step"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <FlowStep side="ar" />
            </Suspense>
          }
        />
        <Route
          path="/accounting/settings"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <AcctSettings />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    {/* E.V.A is mounted once at the app root so she's available on EVERY
        authenticated screen — the Home launcher, every current module, and any
        future module or top-level route — with no per-module wiring. Gated to
        signed-in users (never on the login page) AND to the appConfig.evaEnabled
        flag (VITE_EVA_ENABLED) so she can be turned off without a code change. */}
    {appConfig.evaEnabled && (
      <AuthenticatedTemplate><EvaWidget /></AuthenticatedTemplate>
    )}
    <ToastHost /></ConfettiProvider></ToastProvider>
  );
}
